import { usePinUserSpace } from '#pplx/frontend/apps/ask/hooks/collections-hooks/usePinUserSpace.js';
import { useUnpinUserSpace } from '#pplx/frontend/apps/ask/hooks/collections-hooks/useUnpinUserSpace.js';
import { getUserPinnedSpacesQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/spacesKeys.js';
import { listUserPinnedSpaces } from '#pplx/frontend/apps/ask/queries/spaces-queries/listUserPinnedSpaces.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useCallback, useMemo } from 'react';
export function useUserPinnedSpaces({ reason, enabled = true, }) {
    const { session } = useSession();
    const userEmail = session?.user?.email;
    const query = useQuery({
        queryKey: getUserPinnedSpacesQueryKey(userEmail),
        queryFn: () => listUserPinnedSpaces({ reason }),
        enabled: !!userEmail && enabled,
        placeholderData: undefined,
    });
    const pins = userEmail ? (query.data ?? EMPTY_ARRAY) : EMPTY_ARRAY;
    const { mutate: pin } = usePinUserSpace({ reason });
    const { mutate: unpin } = useUnpinUserSpace({ reason });
    const spaceIsUserPinned = useCallback((collection) => {
        if (!collection?.uuid) {
            return false;
        }
        return pins.some((p) => p.uuid === collection.uuid);
    }, [pins]);
    return useMemo(() => ({
        pins,
        isLoading: userEmail ? query.isLoading : false,
        spaceIsUserPinned,
        pin,
        unpin,
    }), [pins, query.isLoading, spaceIsUserPinned, pin, unpin, userEmail]);
}
//# sourceMappingURL=useUserPinnedSpaces.js.map